import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import React, { Component } from 'react';
import {withRouter} from "react-router-dom";
import "../../assets/scss/order-list.scss";
import AgentCommission from "./AgentCommission"
import SubAgentCommission from "./SubAgentCommission"
import DatePicker from "react-datepicker";
import { Button } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getData } from "../../services/baseServices";
import DepositModal from "./DepositModal"

export const KEYS = {
    AGENT: 0,
    SUBAGENT: 1
}

var today = new Date()
today.setMonth(today.getMonth()-1)

class Collections extends Component {
    constructor() {
        super();
        var startDate = localStorage.getItem("commission_st_d") && localStorage.getItem("commission_st_d") !=="undefined" ? new Date(localStorage.getItem("commission_st_d")): today;

        var seletedTab = localStorage.getItem("commission_tab") ? parseInt(localStorage.getItem("commission_tab")) : KEYS.AGENT;
        
        this.state = {
            start_date: startDate,
            temp_params: { month:  startDate.getMonth()+1, year: startDate.getFullYear() },
            query_params: { month:  startDate.getMonth()+1, year: startDate.getFullYear() }, 
            selectedTab: seletedTab,
            refreshData: false,
            paid_fc_commission: 0,
            paid_partners_margin: 0,
            pending_fc_commission: 0,
            pending_partners_margin: 0,
            total_fc_commission: 0,
            total_partners_margin: 0,
            transaction_type: null
        };
    }

    state = {
        margins: {},
        show: false,
    }

    getCommssions (params) {
        console.log(params)
        getData(`distributors/${this.props.match.params.id}/total_commission_margin`, params)
        .then((res) => {
            if(res?.status_code === 200) this.setState({ margins: res, paid_fc_commission: parseFloat(res.paid_fc_commission), paid_partners_margin: parseFloat(res.paid_partners_margin), pending_fc_commission: parseFloat(res.pending_fc_commission), pending_partners_margin: parseFloat(res.pending_partners_margin), total_fc_commission: parseFloat(res.total_fc_commission), total_partners_margin: parseFloat(res.total_partners_margin) });
        })
        .catch((errMsg) => {
            console.log("Error Message: ", errMsg);
        });
    }

    componentDidMount() {
        this.getCommssions(this.getQueryParams())
    }

    getQueryParams = () => {
        let params = Object.assign(this.state.query_params);
        return params;
    }

    handleOnFilter = (e) => {
        e.preventDefault();
        const tempParam = this.state.temp_params;
        this.setState({query_params: tempParam});
        this.getCommssions(tempParam)
    }

    handleOnApply = (date)=>{
        this.setState({start_date: date})

        localStorage.setItem("commission_st_d", date)
        this.setState({temp_params: {...this.state.temp_params,  month:  date.getMonth()+1, year: date.getFullYear() }})
    }

    onTabChange = (key) => {
        localStorage.setItem("commission_tab", key)
        this.setState({selectedTab: key})
    }

    onClose = (refresh) => {
        this.setState({show: false, transaction_type: null})
        if(refresh){
            this.setState({refresh: true})
            this.getCommssions(this.getQueryParams())
        }
    }

    handlePay = (type) => this.setState({transaction_type: type, show: true})

    render() {
        return (
            <>
                <div className="page-header">
                    <h2 className="page-title">Commission</h2>
                </div>
                    <div align="center">
                        <span className="form-inline mb-3">
                            <div className="form-group mr-3">
                                <label htmlFor="status" className="sr-only">
                                    Date Range
                                </label>
                                <DatePicker
                                    className="form-control"
                                    selected={this.state.start_date}        
                                    onChange={this.handleOnApply}
                                    dateFormat="MMMM-yyyy"
                                    showMonthYearPicker
                                    showFullMonthYearPicker
                                    showFourColumnMonthYearPicker
                                    />
                                {/* <DateRangePicker
                                    initialSettings={{
                                        startDate: this.state.start_date,
                                        endDate: this.state.end_date,
                                        maxSpan: {"months": 3},
                                        showDropdowns: true,
                                        locale: {format: "DD/MM/YYYY"},
                                        autoApply: true,
                                    }}
                                    onApply={(e, picker) => this.handleOnApply(e, picker)}
                                >

                                    <input type="text"
                                        value={this.state.start_date && this.state.end_date ? `${getFormattedDate(this.state.start_date, "DD/MM/YYYY")} - ${getFormattedDate(this.state.end_date, "DD/MM/YYYY")}` : ''}
                                        style={{textAlign: 'left', minWidth: '150px'}}
                                        placeholder={"Select date range"}
                                        className="form-control form-control-sm"/>
                                </DateRangePicker> */}
                            </div>
                            <Button
                                size="sm"
                                // type={`submit`}
                                onClick={this.handleOnFilter}
                                variant="primary"
                            >
                                Filter
                            </Button>
                        </span>
                    </div>
                <div className="card-block">
                    <div className="block-body">
                        <table className="order-table table table-bordered">
                            <thead>
                                <tr>
                                    <th className="text-center">Name</th>
                                    <th className="text-center">Commission</th>
                                    <th className="text-center">Total Paid</th>
                                    <th className="text-center">Total Due</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-center">
                                        Agent
                                    </td>
                                    <td className="text-center">
                                        Tk {parseFloat(this.state.total_fc_commission).toFixed(2)}
                                    </td>
                                    <td className="text-center">
                                        Tk {parseFloat(this.state.paid_fc_commission).toFixed(2)}
                                    </td>
                                    <td className="text-center">
                                        Tk {parseFloat(this.state.pending_fc_commission).toFixed(2)}
                                        {
                                            this.state.pending_fc_commission > 0 ?
                                            <div>
                                                <OverlayTrigger
                                                    key="view"
                                                    placement="top"
                                                    overlay={
                                                    <Tooltip id={`tooltip-view`}>
                                                        Pay
                                                    </Tooltip>
                                                    }
                                                >
                                                    <Button onClick={()=> this.handlePay('agent_commission')}>
                                                        Pay
                                                    </Button>
                                                </OverlayTrigger>
                                            </div>
                                            :
                                            <div>

                                                <Button disabled>
                                                    Pay
                                                </Button>
                                            </div>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td className="text-center">
                                        Sub Agent
                                    </td>
                                    <td className="text-center">
                                        Tk {parseFloat(this.state.total_partners_margin).toFixed(2)}
                                    </td>
                                    <td className="text-center">
                                        Tk {parseFloat(this.state.paid_partners_margin).toFixed(2)}
                                    </td>
                                    <td className="text-center">
                                        Tk {parseFloat(this.state.pending_partners_margin).toFixed(2)}
                                        {
                                            this.state.pending_partners_margin > 0 ?
                                            <div>
                                                <OverlayTrigger
                                                    key="view"
                                                    placement="top"
                                                    overlay={
                                                    <Tooltip id={`tooltip-view`}>
                                                        Pay
                                                    </Tooltip>
                                                    }
                                                >
                                                    <Button onClick={()=> this.handlePay('sub_agent_commission')}>
                                                        Pay
                                                    </Button>
                                                </OverlayTrigger>
                                            </div>
                                            :
                                            <div>

                                                <Button disabled>
                                                    Pay
                                                </Button>
                                            </div>
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <Tabs selectedIndex={this.state.selectedTab} onSelect={this.onTabChange}>
                            <TabList>
                                <Tab eventKey={KEYS.AGENT}>Agent Commission</Tab>
                                <Tab eventKey={KEYS.SUBAGENT}>Sub-Agent Commission</Tab>
                            </TabList>

                            <TabPanel>
                                <AgentCommission queryParams={this.state.query_params} refresh={this.state.refreshData}/>
                            </TabPanel>
                            <TabPanel>
                                <SubAgentCommission queryParams={this.state.query_params} refresh={this.state.refreshData}/>
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
                
                <DepositModal 
                    title={"Send Commission"}
                    handleClose={this.onClose} 
                    show={this.state.transaction_type && this.state.show} 
                    amount={this.state.transaction_type === 'agent_commission' ? this.state.pending_fc_commission : this.state.pending_partners_margin}
                    distributor={this.props.distributor?.name}
                    extraParams= {
                        {
                            distributor_id:this.props.match.params.id, 
                            start_date: this.state.query_params.start_date, 
                            end_date: this.state.query_params.end_date,
                            month: this.state.query_params.month,
                            year: this.state.query_params.year,
                            transaction_type: this.state.transaction_type
                        }
                    }
                    />
            </>
        );
    }
}

export default withRouter(Collections);